import { useAsync } from 'react-use';

import {
  discoveryApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

import { EntityKinds } from '../../types';

export const useTeamOrgTree = (orgType: EntityKinds) => {
  const identityApi = useApi(identityApiRef);
  const discoveryApi = useApi(discoveryApiRef);
  const { value: teamOrgTree } = useAsync(async () => {
    if (orgType === EntityKinds.group) {
      return null;
    }
    const { token } = await identityApi.getCredentials();
    const endpointBase = await discoveryApi.getBaseUrl('common-utilities');

    const response = await fetch(`${endpointBase}/team-tree-by/${orgType}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  });
  return { teamOrgTree };
};
